import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import constants from '../../../utility/constants';
import { CommonCmsComponent } from './common-cms/common-cms.component';
import routeTable from '../../../utility/routeTable';
import { CommonSharedModule } from '../../../shared/shared.module';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';

const routes: Routes = [
  {
    path: routeTable.public.about,
    component: CommonCmsComponent,
    data: constants.public.commonCms.aboutUs,
  },
  {
    path: routeTable.public.valuations,
    component: CommonCmsComponent,
    data: constants.public.commonCms.valuations,
  },
  {
    path: routeTable.public.payments,
    component: CommonCmsComponent,
    data: constants.public.commonCms.payments,
  },
  {
    path: routeTable.public.removal,
    component: CommonCmsComponent,
    data: constants.public.commonCms.removal,
  },
  {
    path: routeTable.public.faq,
    component: CommonCmsComponent,
    data: constants.public.commonCms.faq,
  },
  {
    path: routeTable.public.sellers,
    component: CommonCmsComponent,
    data: constants.public.commonCms.sellers,
  },
  {
    path: routeTable.public.history,
    component: CommonCmsComponent,
    data: constants.public.commonCms.history,
  },
  {
    path: routeTable.public.buyAsset,
    component: CommonCmsComponent,
    data: constants.public.commonCms.buyAssets,
  },
  {
    path: routeTable.public.policy,
    component: CommonCmsComponent,
    data: constants.public.commonCms.privacyPolicy,
  },
  {
    path: routeTable.public.sellAsset,
    component: CommonCmsComponent,
    data: constants.public.commonCms.sellAssets,
  },
  {
    path: routeTable.public.terms,
    component: CommonCmsComponent,
    data: constants.public.commonCms.tAndC,
  },
  {
    path: routeTable.public.valueAsset,
    component: CommonCmsComponent,
    data: constants.public.commonCms.valueAssets,
  },
  {
    path: routeTable.public.whyBranford,
    component: CommonCmsComponent,
    data: constants.public.commonCms.whyBranford,
  },
  {
    path: routeTable.public.assetRecovery,
    component: CommonCmsComponent,
    data: constants.public.commonCms.assetRecovery,
  },
];

@NgModule({
  declarations: [CommonCmsComponent],
  imports: [CommonModule, RecaptchaModule, RecaptchaFormsModule, CommonSharedModule, RouterModule.forChild(routes), AccordionModule.forRoot(),],
})
export class CmsPagesModule {}
